/**
 * Whether the i18n wrapper is currently appending render-key payloads.
 *
 * Default OFF, and only an authenticated editor (`EditModeHost`) ever flips it
 * on — so for every logged-out visitor `useTranslations` is a pure passthrough
 * and the public DOM is byte-identical. The wrapper subscribes via
 * `useSyncExternalStore`, so flipping this re-renders every consumer, which is
 * what lands the payloads in the DOM for the activation-time stamp pass to read.
 * (AHD-7514)
 */

let stampMode = false
const listeners = new Set<() => void>()

export function getStampMode(): boolean {
  return stampMode
}

export function setStampMode(on: boolean): void {
  if (stampMode === on) return
  stampMode = on
  listeners.forEach((l) => l())
}

export function subscribeStampMode(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
